import * as React from 'react'
import { SVGProps } from 'react'
const SvgPackageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      clipPath="url(#PackageIcon_svg__a)"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m12.89 1.95 8 4A2 2 0 0 1 22 7.74v9.53a1.999 1.999 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.79 0l-8-4a2 2 0 0 1-1.1-1.8V7.74a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0v0Z" />
      <path d="M2.32 6.66 12 11.5l9.68-4.84M12 23.26V11.5M7 4l10 5" />
    </g>
    <defs>
      <clipPath id="PackageIcon_svg__a">
        <path
          fill="currentColor"
          transform="translate(0 .5)"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
)
export default SvgPackageIcon
